import {FetchAction, FetchState, getConfigurationCookie} from "App/services";
import {ActionType} from "App/constants";

export var configurationCookieInitialState: any | null = getConfigurationCookie();

export function configurationCookieReducer(state: any|null = configurationCookieInitialState, action: FetchAction) {
    switch (action.type) {
        case ActionType.FETCH_CONFIGURATORPRODUCT:
        case ActionType.CHECK_CONFIGURATION:
        case ActionType.FETCH_CONFIGURATION: {
            switch (action.state) {
                case FetchState.FETCHING: {
                    return {
                        ...state,
                        loading: true
                    }
                }
                case FetchState.SUCCESS: {
                    return {
                        ...getConfigurationCookie(),
                        loading: false
                    }
                }
                default:
                    return {
                        ...state,
                        loading: false
                    };
            }
        }
        case ActionType.DISMISS_CONFIGURATION: {
            switch (action.state) {
                case FetchState.SUCCESS:
                case FetchState.FAILURE:
                    return null
            }
        }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/services/reducers/configurationCookie.ts